import { pureNumberFilterWithZeroCount } from "app/filters/ngFilters";
import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";

/**
 * @deprecated Use ChangeCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/views/change-cell/ChangeCell.tsx}
 */

export const ChangeAbs: FC<ITableCellProps> = ({ value }) => {
    const signClass = value < 0 ? "down2 negative" : value > 0 ? "up2 positive" : "";
    return (
        <div className="text-right changePercentage">
            <span className={`sw-icon-arrow-${signClass}`}> {pureNumberFilterWithZeroCount(Math.abs(value), 2)}</span>
        </div>
    );
};
